import { createSelectorHooks } from 'auto-zustand-selectors-hook';
import { create } from 'zustand';

import { type SchoolClass } from '$/services/usecases/school/mapper/schoolClasses';

type SchoolClassModalMode = 'deleteClass' | 'renameClass' | 'createClass';

type SchoolClassModalProps = {
  isOpen: boolean;
  modalMode: SchoolClassModalMode;
  schoolClass: SchoolClass | null;
  onClose: () => void;
  onOpen: (
    mode: SchoolClassModalMode,
    schoolClass?: SchoolClass | null,
  ) => void;
};

const store = create<SchoolClassModalProps>()((set) => ({
  isOpen: false,
  modalMode: 'deleteClass',
  schoolClass: null,
  onClose: () => {
    set({ isOpen: false, schoolClass: null });
  },
  onOpen: (mode, schoolClass = null) =>
    set({ modalMode: mode, isOpen: true, schoolClass }),
}));

export const useSchoolClassModal = createSelectorHooks(store);
